export var EXTERNAL_PROTOTYPE_LOADING = 'EXTERNAL_PROTOTYPE_LOADING';
export var EXTERNAL_PROTOTYPE_LOADED = 'EXTERNAL_PROTOTYPE_LOADED';
